/**
 * How a document type reads on screen. The API sends enum values (`BUSINESS_W9`, `CMS1500`);
 * people read forms by their own names.
 *
 * Shared by both apps, so the support and provider enums both pass through here — they hold the
 * same values for the types they share.
 */
const LABELS: Record<string, string> = {
    B2B_INVOICE: 'B2B Invoice',
    EXPLANATION_OF_BENEFITS: 'EOB',
    CMS1500: 'CMS-1500',
    CMS1450: 'CMS-1450',
    NYNF3: 'NY NF-3',
    AI_MAIL: 'AI Mail',
    AI_FAX: 'AI Fax',
    AI_PHONE: 'AI Phone',
    AI_CLAIM: 'AI Claim',
    BUSINESS_W9: 'W-9',
    BUSINESS_CC_STMT: 'Business Credit Card Statement',
    BUSINESS_BANK_STMT: 'Business Bank Statement',
    BUSINESS_PROCESSING_STMT: 'Business Processing Statement',
    BUSINESS_SIGNOR_ID: 'Business Signer ID',
};

/** `BUSINESS_W9` → `W-9`; anything without a name of its own is title-cased: `MEDICAL_RECORDS` → `Medical Records`. */
export function fileCabinetDocumentTypeLabel(type: string | undefined): string {
    if (!type) {
        return '';
    }
    return (
        LABELS[type] ??
        type
            .toLowerCase()
            .split('_')
            .filter(Boolean)
            .map(word => word[0].toUpperCase() + word.slice(1))
            .join(' ')
    );
}

/** `DEPRECATED_ITEM` is a value no one should filter by; every other display type is offered. */
export function fileCabinetFilterableDocumentTypes(types: string[]): string[] {
    return types
        .filter(type => type !== 'DEPRECATED_ITEM')
        .sort((a, b) => fileCabinetDocumentTypeLabel(a).localeCompare(fileCabinetDocumentTypeLabel(b)));
}
